module.exports = __webpack_public_path__ + "static/cia_1_cropped_2-6e5c1cb6495c9a451efc9f29897d2faa.png";